import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTable } from '@angular/material/table';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { TilvalgDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/tilvalg-dto';
import { TilvalgGroupDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/tilvalg-group-dto';
import { AuditHistoryEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/audit-history-enum';
import { TilvalgService } from 'src/app/api/services';
import { HistoryViewComponent } from 'src/app/components/shared/history/history-view/history-view.component';
import { IHistoryView } from 'src/app/components/shared/history/history.model';
import { EGIS_SERVICE_CALLER } from 'src/app/constants';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { LoaderService } from 'src/app/services/loader.service';
import { TilvalgEditDialogComponent } from '../tilvalg-edit-dialog/tilvalg-edit-dialog.component';

@Component({
  selector: 'app-tilvalg-list',
  templateUrl: './tilvalg-list.component.html',
  styleUrls: ['./tilvalg-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TilvalgListComponent implements OnInit, OnDestroy {
  tilvalgGroups: TilvalgGroupDto[] = [];
  @ViewChild(MatTable) table: MatTable<any>;
  displayedColumns: string[] = ['name', 'tilvalgType', 'okKundeVarenr', 'actions'];
  canEdit: boolean = true;
  unsubscribe$ = new Subject<void>();

  constructor(
    private service: TilvalgService,
    private dialog: MatDialog,
    private errorHandler: ErrorHandlerService,
    private loader: LoaderService,
  ) {}

  @ViewChild(HistoryViewComponent) historyViewComponent: HistoryViewComponent;

  historyView: IHistoryView;

  ngOnInit(): void {
    this.getData();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }

  getData() {
    this.loader.show();
    this.service
      .getTilvalgGroups({
        caller: EGIS_SERVICE_CALLER,
      })
      .pipe(
        takeUntil(this.unsubscribe$),
        finalize(() => {
          this.loader.hide();
        }),
      )
      .subscribe(
        (tilvalgGroups: TilvalgGroupDto[]) => {
          this.tilvalgGroups = tilvalgGroups;
        },
        (error) => {
          this.errorHandler.HandleError(error);
        },
      );
  }

  getTilvalg(group: TilvalgGroupDto) {
    return group.tilvalg;
  }

  add() {
    this.edit(null);
  }

  edit(row: TilvalgDto) {
    let dialogRef = this.dialog.open(TilvalgEditDialogComponent, {
      width: '600px',
      maxWidth: '95vw',
      data: {
        tilvalg: row,
        tilvalgGroups: this.tilvalgGroups,
      },
    });

    dialogRef.afterClosed().subscribe((p) => {
      this.getData();
      // if (p) {
      //   if (row) {
      //     const reload = this.historyView;
      //     Object.assign(row, p);
      //     if (reload) this.showhistory(row);
      //     this.historyViewComponent.render();
      //   } else {
      //     this.fabrikater.push(p);
      //     this.historyView = null;
      //   }
      //   this.table.renderRows();
      // }
    });
  }

  showhistory(row: TilvalgDto) {
    this.historyView = { entityId: row.id, historyType: AuditHistoryEnum.Tilvalg, title: `${row.name} ${row.tilvalgnr}` };
  }
}
